












import Vue from "vue";
import { NavigationButtonInterface } from "@/types";
import { mapState } from "vuex";
import { ResponseStatus } from "@/constants/ajax";

export default Vue.extend({
  name: "NavigateButton",
  props: {
    pathName: String,
    text: {
      type: String,
      default: '',
    },
    defaultLook: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultStep: "mobileReturnToDesktop",
      isHybrid: false,
    } as NavigationButtonInterface;
  },
  mounted() {
    this.isHybrid = this.isHybridPath;
  },
  methods: {
    async navigateStep(): Promise<any> {
      if (this.isHybrid && !this.checkWindowPathName()) {
        const ajaxService = this.$store.state.ajaxService;
        const data = await ajaxService.post(ajaxService.PROXY_ROUTE + "form-pl/skip-hybrid-upload", {
          token: ajaxService.getToken(),
        });
        if (ResponseStatus.SUCCESS === data.status) {
          await this.$store.state.navigationService.goToRoute(this.defaultStep);
        } else {
          this.newError();
        }
        this.$emit("click");
      } else {
        this.$emit("click");
        await this.$store.state.navigationService.goToRoute(this.pathName);
      }
    },

    checkWindowPathName(): boolean {
      return window.location.pathname.indexOf("document-selection") > -1;
    },

    newError(): void {
      // todo: proper error handling
      console.error("AN UNEXPECTED ERROR HAS BEEN TAKEN");
    },
  },
  computed: {
    ...mapState({
      isHybridPath: (state: any) => state.formData.isHybrid,
    }),
  },
});
